import { render } from "./bookingroom.vue?vue&type=template&id=27ca33a4"
import script from "./bookingroom.vue?vue&type=script&lang=js"
export * from "./bookingroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__